import Original from 'ol/renderer/webgl/VectorLayer.js';
import VectorStyleRenderer from '../../render/webgl/VectorStyleRenderer.js';

export default class WebGLVectorLayer extends Original {
  constructor(layer, options) {
    super(layer, options);
  }

  createRenderers_() {
    this.buffers_ = [];
    // if(this.style_ instanceof Array){
    //   this.styleRenderer_ = this.style_.map(
    //     (style) =>
    //       new VectorStyleRenderer(
    //         style,
    //         this.styleVariables_,
    //         this.helper,
    //         this.hitDetectionEnabled_,
    //         'filter' in style ? style.filter : null,  
    //       ),
    //   );
    // }else{
    this.styleRenderer_ = new VectorStyleRenderer(
      this.style_,
      this.styleVariables_,
      this.helper,
      this.hitDetectionEnabled_,
      'filter' in this.style_ ? this.style_.filter : null,
    );
  // }
  }

   createRenderers_() {
    this.buffers_ = null;
    this.styleRenderer_ = new VectorStyleRenderer(
      this.style_,
      this.styleVariables_,
      this.helper,
      this.hitDetectionEnabled_,
      'filter' in this.style_ ? this.style_.filter : null,
    );
  }
}
